module.exports = __webpack_public_path__ + "static/media/auchan2.6941ad60.jpg";